module.exports = __webpack_public_path__ + "media/3-12.90047d48.wav";